// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define global styles for the blog list container */
.blog-list {
  margin: 0 auto; /* Center container */
  border-radius: 10px;
  font-family: Arial, sans-serif;
  /* background-image: linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%); */
  padding: 20px;
  max-width: 100%;
  box-sizing: border-box;
  width: 90%; /* Add width to avoid too much space on large screens */
}

/* Grid layout for blog items */
.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); /* Responsive grid */
  gap: 20px; /* Space between grid items */
}

/* Styles for each blog item */
.blog-item {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 15px;
  box-sizing: border-box;
  /* background-image: linear-gradient(to top, #d5dee7 0%, #ffafbd 0%, #c9ffbf 100%); */
  transition: transform 0.3s ease-in-out; /* Zoom effect */
  display: flex;
  flex-direction: column; /* Stack image and text vertically */
}

/* Blog content styling */
.blog-content {
  display: flex;
  flex-direction: column; /* Stack image and text vertically */
  height: 100%; /* Take up full height available in the card */
}

/* Blog header section */
.blog-header {
  margin-bottom: 10px;
}

/* Blog title styling */
.blog-title {
  font-size: 1.5em;
  margin: 0;
  font-weight: bold;
}

/* Blog details section */
.blog-details {
  display: flex;
  flex-direction: column; /* Stack image and text vertically */
}

/* Blog image styling */
.blog-image {
  max-width: 100%; /* Responsive image width */
  height: auto; /* Maintain aspect ratio */
  border-radius: 8px;
  margin-bottom: 10px; /* Space below the image */
}

/* Show more/less button styling */
.show-more-btn,
.show-less-btn {
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  margin-top: 10px;
  font-size: 1em; /* Consistent button size */
}

/* Button hover effects */
.show-more-btn:hover,
.show-less-btn:hover {
  background-color: #0056b3;
}

/* Remove underline from links */
a {
  text-decoration: none;
  color: inherit; /* Maintain text color */
}

/* Zoom effect on blog item */
.blog-item:hover {
  transform: scale(1.05); /* Slight zoom effect */
}

/* Media queries for responsiveness */

/* For tablets and smaller desktops */
@media (max-width: 1024px) {
  .blog-grid {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); /* Responsive grid */
  }
}

/* For mobile screens */
@media (max-width: 768px) {
  .blog-details {
    flex-direction: column; /* Stack image and content vertically */
  }

  .blog-image {
    margin-bottom: 10px; /* Space below image */
    max-width: 100%; /* Ensure image fits within the container */
  }

  .show-more-btn,
  .show-less-btn {
    margin-top: 15px;
    font-size: 0.9em; /* Smaller button text on mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Blogs/Blog.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,cAAc,EAAE,qBAAqB;EACrC,mBAAmB;EACnB,8BAA8B;EAC9B,yEAAyE;EACzE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,UAAU,EAAE,uDAAuD;AACrE;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,2DAA2D,EAAE,oBAAoB;EACjF,SAAS,EAAE,6BAA6B;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,qFAAqF;EACrF,sCAAsC,EAAE,gBAAgB;EACxD,aAAa;EACb,sBAAsB,EAAE,oCAAoC;AAC9D;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;EAC5D,YAAY,EAAE,8CAA8C;AAC9D;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB,EAAE,oCAAoC;AAC9D;;AAEA,uBAAuB;AACvB;EACE,eAAe,EAAE,2BAA2B;EAC5C,YAAY,EAAE,0BAA0B;EACxC,kBAAkB;EAClB,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA,kCAAkC;AAClC;;EAEE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAE,2BAA2B;AAC7C;;AAEA,yBAAyB;AACzB;;EAEE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,cAAc,EAAE,wBAAwB;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB,EAAE,uBAAuB;AACjD;;AAEA,qCAAqC;;AAErC,qCAAqC;AACrC;EACE;IACE,2DAA2D,EAAE,oBAAoB;EACnF;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB,EAAE,uCAAuC;EACjE;;EAEA;IACE,mBAAmB,EAAE,sBAAsB;IAC3C,eAAe,EAAE,2CAA2C;EAC9D;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB,EAAE,kCAAkC;EACtD;AACF","sourcesContent":["/* Define global styles for the blog list container */\n.blog-list {\n  margin: 0 auto; /* Center container */\n  border-radius: 10px;\n  font-family: Arial, sans-serif;\n  /* background-image: linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%); */\n  padding: 20px;\n  max-width: 100%;\n  box-sizing: border-box;\n  width: 90%; /* Add width to avoid too much space on large screens */\n}\n\n/* Grid layout for blog items */\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); /* Responsive grid */\n  gap: 20px; /* Space between grid items */\n}\n\n/* Styles for each blog item */\n.blog-item {\n  border-radius: 10px;\n  border: 1px solid #ccc;\n  padding: 15px;\n  box-sizing: border-box;\n  /* background-image: linear-gradient(to top, #d5dee7 0%, #ffafbd 0%, #c9ffbf 100%); */\n  transition: transform 0.3s ease-in-out; /* Zoom effect */\n  display: flex;\n  flex-direction: column; /* Stack image and text vertically */\n}\n\n/* Blog content styling */\n.blog-content {\n  display: flex;\n  flex-direction: column; /* Stack image and text vertically */\n  height: 100%; /* Take up full height available in the card */\n}\n\n/* Blog header section */\n.blog-header {\n  margin-bottom: 10px;\n}\n\n/* Blog title styling */\n.blog-title {\n  font-size: 1.5em;\n  margin: 0;\n  font-weight: bold;\n}\n\n/* Blog details section */\n.blog-details {\n  display: flex;\n  flex-direction: column; /* Stack image and text vertically */\n}\n\n/* Blog image styling */\n.blog-image {\n  max-width: 100%; /* Responsive image width */\n  height: auto; /* Maintain aspect ratio */\n  border-radius: 8px;\n  margin-bottom: 10px; /* Space below the image */\n}\n\n/* Show more/less button styling */\n.show-more-btn,\n.show-less-btn {\n  padding: 5px 10px;\n  border: none;\n  cursor: pointer;\n  background-color: #007bff;\n  color: #fff;\n  border-radius: 4px;\n  margin-top: 10px;\n  font-size: 1em; /* Consistent button size */\n}\n\n/* Button hover effects */\n.show-more-btn:hover,\n.show-less-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Remove underline from links */\na {\n  text-decoration: none;\n  color: inherit; /* Maintain text color */\n}\n\n/* Zoom effect on blog item */\n.blog-item:hover {\n  transform: scale(1.05); /* Slight zoom effect */\n}\n\n/* Media queries for responsiveness */\n\n/* For tablets and smaller desktops */\n@media (max-width: 1024px) {\n  .blog-grid {\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); /* Responsive grid */\n  }\n}\n\n/* For mobile screens */\n@media (max-width: 768px) {\n  .blog-details {\n    flex-direction: column; /* Stack image and content vertically */\n  }\n\n  .blog-image {\n    margin-bottom: 10px; /* Space below image */\n    max-width: 100%; /* Ensure image fits within the container */\n  }\n\n  .show-more-btn,\n  .show-less-btn {\n    margin-top: 15px;\n    font-size: 0.9em; /* Smaller button text on mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
